import { useCallback, useRef } from "react";

import {
  loadMentionMeReferreroffer,
  MentionMeReferrerofferParams,
} from "../integrations/mentionMe/MentionMeLoader";

export function useMentionMePopup() {
  const cleanupRef = useRef<() => void>();

  const openMentionMePopup = useCallback((params: MentionMeReferrerofferParams) => {
    // Remove old loader DOM elements
    const id = "referreroffer-loader-id";
    document.getElementById(id)?.remove();
    // Reset MentionMe tags
    if (window.MentionMeFiredTags) {
      const tagName = (params.implementation ?? "popup") + (params.situation ?? "postpurchase");
      delete window.MentionMeFiredTags[tagName];
    }
    // Clear the popup wrapper DOM element
    const mmWrapper = document.getElementById("mmWrapper");
    if (mmWrapper && params.implementation === "popup") {
      mmWrapper.innerHTML = "";
    }
    // Load MentionMe
    cleanupRef.current = loadMentionMeReferreroffer(params);
  }, []);

  const cleanupMentionMePopup = useCallback(() => {
    cleanupRef.current?.();
    cleanupRef.current = undefined;
  }, []);

  return {
    openMentionMePopup,
    cleanupMentionMePopup,
  };
}
